class LocalStore {
  constructor () {

  }
  store (key, value) {
    if (typeof value === 'object') {
      window.localStorage.setItem(key, JSON.stringify(value))
    } else {
      window.localStorage.setItem(key, value)
    }
  }
  get (key) {
    let value = window.localStorage.getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }
}
class SessionStore {
  constructor () {

  }
  store (key, value) {
    if (typeof value === 'object') {
      window.sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      window.sessionStorage.setItem(key, value)
    }
  }
  get (key) {
    let value = window.sessionStorage.getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }
}

export default new LocalStore()

const sessionStore = new SessionStore()
export {
  sessionStore
}